<template>
    <split-pane  :min-percent='20' :default-percent='52' split="vertical" style="background:white; height:100%">
        <template slot="paneL">
            <div style="display:flex; height:35px;font-size:12px;font-weight:700;color:#333;margin-left:5px">  
                <div  class="oneTab">
                    <div  :class="{active: v_tabName==='user'}" @click="itemClick('user')">
                        <i class="iconfont icon-yonghu-xianxing" style="font-size:16px; "></i>
                        角色-用户权限
                    </div> 
                </div>
                <!-- <div  class="oneTab" style="margin-left:30px">
                    <div  :class="{active: v_tabName==='out'}" @click="itemClick('out')">
                        <i class="iconfont iconfont icon-yonghu-yuan" style="font-size:16px; "></i>
                        公司外部用户
                    </div> 
                </div> -->
            </div>
            <div v-if="v_tabName=='user'" style="margin-top:2px">
                <div style="width:100%; background:#f7f8f9;line-height:30px;height:38px; border-bottom:2px solid #389">
                    <div style="min-width:800px;display:flex;border-top:1px solid #ccc">
                        <el-input type="text" clearable :placeholder="input_hold" v-model="txtparam" size="small" style="width:340px; height:30px;margin-left:4px "  @keyup.enter.native="qryTabData">
                            <el-select v-model="selparam" slot="prepend" placeholder="请选择列名" clearable  @change="elchange" style="width:120px; background:white; height:30px;">
                                <span v-for="item in roleCol.filter(item=>item.thide=='N')" :key='item.key'>
                                    <el-option :label="item.title" :value="item.key"></el-option>
                                </span>
                            </el-select>
                            <el-button slot="append" size="small" icon="el-icon-search" @click="qryTabData" style="font-size:14px;color:#409EFF"></el-button>
                        </el-input> 
                        <el-button @click="addRole" type="primary" icon="iconfont icon-xinzeng"  size="mini" style="margin-top:-2px;margin-left:15px"><span style="font-size:13px;">新增</span></el-button>  
                        <el-button @click="saveRec('IN')" type="danger" size="mini" icon="iconfont icon-baocun" style="margin-left:15px" ><span style="font-size:13px;margin-left:5px">保存权限</span></el-button>
                    </div>  
                </div>
                <el-table  :data="roleData" 
                        border                            
                        size="small"
                        ref="refrole"                   
                        :cell-style="{padding:'2px',color:'black','font-size':'12px','margin-top':'4px'}"
                        :row-key="getRowKey"
                        highlight-current-row
                        @row-click="rowClick"
                        class="custom-table-border"
                        style="margin-top:-4px"
                        height="230px" >
                    <el-table-column label="序号" type="index" :min-width="55" align="left"></el-table-column> 
                    <el-table-column  :key="index" v-for="(item ,index) in roleCol.filter(item=>item.thide=='N')"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'"
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <el-tag  v-if="item.edcss=='checkbox'&&scope.row[item.key]=='Y'" size="mini" type="success" effect="dark">是</el-tag>
                            <el-tag  v-else-if="item.edcss=='checkbox'&&scope.row[item.key]=='N'" size="mini" type="danger" effect="dark">否</el-tag>                         
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="260">
                        <template slot-scope="scope">
                            <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link   @click="addRec(scope.row)" :underline="false"  ><span style="font-size:12px;margin-right:5px; ">新增用户</span></el-link>
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link   @click="roleEdit(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px; ">编辑</span></el-link>
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link   @click="roleDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px; ">删除</span></el-link>
                            <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:12px;margin-right:5px; "></i>
                            <el-link   @click="cpRec(scope.row  )" :underline="false"  ><span style="font-size:12px;margin-right:2px;">复制角色</span></el-link> 
                        </template>
                    </el-table-column> 
                </el-table>
                <el-table  :data="userData" 
                        border             
                        class="custom-table-border"               
                        size="small"
                        ref="refuser"
                        :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                        :row-key="getRowKey"
                        header-cell-class-name="clearPadding"
                        :header-cell-style="{ 'color':'#389','text-align':'center'}"
                        highlight-current-row         
                        :height="userHigh" >
                    <el-table-column label="序号" type="index" width="60" fixed>
                        <el-table-column label="序号" type="index" width="60" fixed>
                            <template slot="header"  >
                                <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                                    <el-tooltip content=" 清除条件" effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column v-for="(item ,index) in userCol.filter(item=>item.thide=='N')" :key="index"  
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'"
                        :min-width="item.width">
                        <el-table-column  resizable :prop="item.key" :align="item.align"  :label="item.title" show-overflow-tooltip :min-width="item.width">
                            <template slot="header" slot-scope="scope">
                                {{scope.row}}
                                <el-select v-if="item.key=='ISADMIN'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                                    <el-option label="是" value="Y"  ></el-option>
                                    <el-option label="否" value="N"  ></el-option>
                                </el-select>
                                <el-select v-else-if="item.key=='STFG'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                                    <el-option label="是" value="X"  ></el-option>
                                    <el-option label="否" value="N"  ></el-option>
                                </el-select>
                                <el-date-picker v-else-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                                <el-input type="number" placeholder="数字框"  @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                                <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                            </template>
                            <template slot-scope="scope">
                                <el-checkbox v-if="item.key=='STFG'" disabled true-label="X"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                <el-checkbox v-else-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                <el-tag  v-else-if="item.key=='ISADMIN'&&scope.row['ISADMIN']=='Y'" size="mini" type="success" effect="dark">是</el-tag>
                                <el-tag  v-else-if="item.key=='ISADMIN'&&scope.row['ISADMIN']=='N'" size="mini" type="info" effect="dark">否</el-tag>                         
                                <span v-else v-text="scope.row[item.key]" ></span>
                            </template>
                        </el-table-column>
                    </el-table-column>            
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="180">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ISAI=='N'" >
                                <el-link  @click="setRec(scope.row,scope.$index,'Y')" :underline="false" style="margin-top:-2px;"><span style="font-size:12px;margin-right:5px"> 设置AI </span></el-link>   
                            </span>
                            <span v-if="scope.row.ISAI=='Y'" >
                                <el-link  @click="setRec(scope.row,scope.$index,'N')" :underline="false" style="margin-top:-2px;"><span style="font-size:12px;margin-right:5px"> 取消AI</span> </el-link>  
                            </span>
                            <i class="iconfont icon-shuaxin" style="color:#409EFF;font-size:12px;margin-right:5px;margin-left:5px; "></i>
                            <el-link  @click="setPwd(scope.row)" :underline="false" style="margin-top:-2px;"><span style="font-size:12px;margin-right:5px">重置密码</span></el-link>   
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;margin-left:5px;"></i>
                            <el-link   @click="userDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:2px;">删除</span></el-link> 
                        </template>
                    </el-table-column> 
                </el-table>
                <!-- 分页查询 -->
                <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
                    <div style="float: left;padding-left:4px;font-size:12px;">
                        <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                    </div>
            
                </div>
            </div>
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :visible.sync="promtWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="promtWin = false">确 定</el-button>
                </span>
            </el-dialog>
    
        
        </template>
        <template slot="paneR">
 
            <div style="display:flex;  height:52px;font-size:14px;font-weight:700;color:#333;margin-left:5px">  
                <div  class="tabMenu">
                    <div  :class="{active: tabVal==='tab01'}" @click="tabClick('tab01')">
                        <i class="iconfont icon-mokuai" style="font-size:18px; "></i>
                        模块-表单权限
                    </div> 
                </div>
                <div  class="tabMenu" style="margin-left:30px">
                    <div  :class="{active: tabVal==='tab02'}" @click="tabClick('tab02')">
                        <i class="iconfont icon-a-baobiaoguanlibaobiao" style="font-size:18px; "></i>
                        模块-报表权限
                    </div> 
                </div>
                
            </div>
            <div v-if="tabVal=='tab01'" style="margin-top:-12px">
                <div style="overflow:auto" :style="{height:tableHigh }">   
                        <template v-for="(item, index) in menuList" > 
                            <div  class="oneMenu" :key="index" >
                                <div style=" width:200px;"> {{item.name}} <i @click="menuClick(index,item.code)" :class="listIndex===index&&menuBool?'el-icon-arrow-up':'el-icon-arrow-down'" style="margin-left:10px;"></i> </div>
                                <div style=" width:80px; ">查看<el-checkbox v-model="item.sel" @change="modSelect('S',index,item.sel)" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                <div style=" width:80px; ">新增<el-checkbox v-model="item.ins" @change="modSelect('I',index,item.ins)" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                <div style=" width:80px; ">修改<el-checkbox v-model="item.upd" @change="modSelect('U',index,item.upd)" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                <div style=" width:80px; ">作废<el-checkbox v-model="item.del" @change="modSelect('D',index,item.del)" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                <div style=" width:80px; ">审核<el-checkbox v-model="item.cfm" @change="modSelect('C',index,item.cfm)" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                <div style=" width:80px; ">下推<el-checkbox v-model="item.cancel" @change="modSelect('X',index,item.cancel)" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                <div style=" width:80px; ">确认<el-checkbox v-model="item.exp" @change="modSelect('E',index,item.exp)" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                <div style=" width:80px; ">自己<el-checkbox v-model="item.oth" @change="modSelect('T',index,item.oth)" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                            </div>
                            <template v-for="(subitem ) in item.children">
                                <span :key="`${subitem.frmurl}`+'-'+`${subitem.modidseq}`"  v-if="openName.indexOf(item.code)>-1">
                                    <div  class="twoMenu">
                                        <div style="display:flex">
                                            <div style=" width:200px;font-size:12px;" >{{subitem.name}} </div>
                                            <div style=" width:80px;margin-left:14px;"><el-checkbox v-model="subitem.sel" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                            <div style=" width:80px; "><el-checkbox v-model="subitem.ins" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                            <div style=" width:80px; "><el-checkbox v-model="subitem.upd" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                            <div style=" width:80px; "><el-checkbox v-model="subitem.del" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                            <div style=" width:80px; "><el-checkbox v-model="subitem.cfm" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                            <div style=" width:80px; "><el-checkbox v-model="subitem.cancel" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                            <div style=" width:80px; "><el-checkbox v-model="subitem.exp" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                            <div style=" width:80px; "><el-checkbox v-model="subitem.oth" style="margin-left:5px;" false-label="N"  true-label="Y"></el-checkbox></div>
                                        </div>
                                    </div>
                                </span>
                            </template>
                        </template>  
                        
                </div> 
            </div>
            <div v-if="tabVal=='tab02'" style="margin-top:-12px">
                <div style="width:100%; background:#f7f8f9;line-height:30px;height:33px; padding-left:2px;border-bottom:2px solid #389">
                    <span style="font-weight:600;font-size:12px;color:#409eff"> <i class="iconfont icon-yuandian" style="color:red"></i> 模块明细 </span>
                </div>
                <el-table  :data="modData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :cell-style="{padding:'2px'}"
                    :height="250" 
                    ref="refmod"
                    :row-key="getRowKey"
                    @row-click="modRow"
                    highlight-current-row>
                    <el-table-column  v-for="(item,index ) in modCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                    </el-table-column>                           
                </el-table> 
                <div style="width:100%; background:#f7f8f9;line-height:35px;height:37px; padding-left:2px;border-bottom:2px solid #389">
                    <div style=" width:700px">
                    <span style="font-weight:600;font-size:12px;color:#409eff"> <i class="iconfont icon-yuandian" style="color:red"></i> 表单报表 </span>
                    <el-button type="text" size="mini" icon="iconfont icon-xinzeng" @click="addRep" style="margin-left:15px" >新增</el-button>
                    <el-select v-model="selparam3" size="small"  placeholder="请选择列名" clearable  style="width:150px;margin-left:20px">
                        <span v-for="item in repCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                        </span>
                    </el-select>
                    <el-input   v-model="txtparam3" @keyup.enter.native="repChange" size="small" style="width:320px; vertical-align:center;height:30px;">
                        <el-select v-model="oper3" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="repChange" style="color:#409eff"></el-button>
                    </el-input>
                    </div>
                </div>
                <el-table  :data="repData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="repHigh" 
                    :cell-style="{padding:'2px'}"
                    ref="refrep"
                    :row-key="getDtlKey"
                    highlight-current-row>
                    <el-table-column  v-for="(item,index ) in repCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                    </el-table-column>   
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px; "></i>
                            <el-link :disabled="disabled" @click="delRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                         
                </el-table> 
            </div>
            
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog> 
            <!-- 分配报表-->
            <el-dialog  v-dialogDrag :visible.sync="repWin"  width="1100px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">分配报表</span>
                </div>
                <Form :model="repRow" :label-width="120"  label-position="right" inline  >  
                    <span v-for="(item,index) in repCol" :key="index" >
                        <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                            <el-input readonly  @focus="inputBtn('REP')" v-model="repRow[item.key]"  v-if="item.key==='REPIDSEQ'"  style="width:100%"> </el-input>
                            <el-input v-else type="text" :disabled="item.disabled==='Y'?true:false "  v-model="repRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form> 
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="repWin = false" style="margin-right:40px;">取 消</el-button>
                    <el-button type="primary" size="small" @click="repSure">确 定</el-button>
                </span>
            </el-dialog> 
            
            <!-- 引用选择框 -->
            <el-dialog  v-dialogDrag v-if="btnWin"  :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
                </div> 
                <pub-win v-bind:tabCol ="tableCol" ref="refWin" v-bind:v_cond="v_cond" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
            </el-dialog> 
            <el-dialog  v-dialogDrag v-if="rptWin"  :visible.sync="rptWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
                </div> 
                <rep-dlg v-bind:tabCol ="tableCol" ref="refRpt" v-bind:v_cond="v_cond" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="rptWin=false" @child-sure="btnSure"></rep-dlg>                
            </el-dialog>
            <!-- 密码修改 -->
            <el-dialog :visible.sync="pwdWin" width="600px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">      
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">修改密码</span>
                </div> 
                <Form  v-model="pwdform"  :label-width="110"   label-position="right" inline > 
                    <FormItem  label="新密码"  style="width:97%" prop="NEWPWD">                  
                        <el-input  show-password
                                placeholder="请输入新密码(长度不少于6位)"
                                type="password"
                                v-model="NEWPWD"> 
                            <template slot ="prepend" ><i class="el-icon-lock" style="color:#409EFF"></i></template>
                        </el-input>           
                    </FormItem>
                    <FormItem  label="确认密码" style="width:97%"  prop="CFMPWD">                  
                        <el-input  show-password
                                placeholder="请确认新密码(长度不少于6位)"
                                type="password"
                                v-model="CFMPWD"> 
                            <template slot ="prepend" ><i class="el-icon-lock" style="color:#409EFF"></i></template>
                        </el-input>           
                    </FormItem>
                </Form>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right" >
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="pwdWin=false" style="margin-right:50px;">取消</el-button>
                        <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="pwdCfm" style="margin-right:10px;">确定</el-button>           
                    </span>
                </div>
            </el-dialog> 
            <!-- 复制权限 -->
            <el-dialog :visible.sync="cpWin" width="400px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">      
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">复制用户权限</span>
                </div> 
                <div style="line-height:50px; height:50px ;display:flex">
                    <div style="line-height:50px;width:90px;font-size:12px" >源角色：</div>
                    <el-select style="width:100%" v-model="v_fruser" filterable  @change="frChange(v_fruser)">
                        <el-option v-for ="(item,index) in roleArr" :key="index" :label="item.ROLENM" :value="item.IDSEQ"></el-option>
                    </el-select>
                </div>
                <div style="line-height:50px; height:50px ;display:flex">
                    <div style="line-height:50px;width:90px;font-size:12px" >目标角色：</div>
                    <el-input style="width:100%" v-model="v_tousernm" disabled ></el-input>
                </div>
                <div style="line-height:50px; height:50px ;display:flex">
                    <div style="line-height:50px;width:90px;font-size:12px" >目标编码：</div>
                    <el-input style="width:100%" v-model="v_touser" disabled ></el-input>
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                    <span style="float:right" >
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="cpWin=false" style="margin-right:50px;">取消</el-button>
                        <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="cpSave" style="margin-right:5px;">确定</el-button>           
                    </span>
                </div>
            </el-dialog>  
            <!-- 角色编辑 -->
            <el-dialog  v-dialogDrag  :visible.sync="roleWin" width="800px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 新增角色</span>
                </div> 
                <Form :model="roleRow" :label-width="110"   label-position="right" inline  >  
                    <span v-for="(item,index) in roleCol" :key="index" >
                        <FormItem  class="item-width"   v-if="item.fhide==='N'" :prop="item.key"  >  
                            <template slot="label"><span v-if="item.notnull=='Y'" style="color:red">* </span>{{item.title}}</template>             
                            <el-checkbox size="small"   border v-if="item.edcss=='checkbox'"  true-label="Y"  false-label="N" v-model="roleRow[item.key]" style="width:100%;"> &nbsp;</el-checkbox> 
                            <el-input  :disabled="item.disabled=='Y'"  type="text" v-else   v-model="roleRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                    <span style="float:right">
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="roleWin=false" style="margin-right:25px;">取消</el-button>
                        <el-button   type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRole" style="margin-right:10px;">保存</el-button>
                    </span>
                </div>
            </el-dialog> 
            <!-- 新增用户提示框 -->
            <el-dialog  v-dialogDrag  :visible.sync="empWin" width="450px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                    <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">请确认新增用户时的数据来源</div>
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                    <span style="float:right">
                        <el-button type="info" size="small"  @click="addEmp('S')" style="margin-right:20px;">引用供应商</el-button>
 
                        <el-button type="primary" size="small"   @click="addEmp('Y')"  >引用人员档案</el-button>
                    </span>
                </div>
            </el-dialog>
        </template>     
    </split-pane>
</template>
<script>
import { getTabColOrData ,getBaseData,getTab_Column} from '../../api/user' 
import pubWin from '../datamgt/pubmulti.vue'
import repDlg from '../datamgt/rep_priv.vue'
export default {
    name: 'sys_userpriv',
    data () {
        return {
            empWin:false,
            v_empRow:{}, 
            v_row:{},
            cpWin:false,
            v_fruser:'',
            v_frusernm:'',
            v_touser:'',
            v_tousernm:'',
            pwdWin:false,
            pwdform:{},
            NEWPWD:'',
            CFMPWD:'',
            modCol:[],
            tableCol:[],
            v_table:'',
            v_key:'',
            v_key2:'',
            v_value2:'',
            promptWin:false,
            prompt:'',
            tabVal:'tab01',
            v_tabName:'user',
            operArr:[],
            current:1,
            empCol:[],
            supArr:[],
            t_cond:'',
 
            menuBool:false,
 
            promtWin:false,
            repCol:[],
            v_cond:'',
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'ROLENM',// select 绑定值
            txtparam:'', // input 绑定值
            selparam2:'USERNO',// select 绑定值
            txtparam2:'', // input 绑定值
            selparam3:'',
            txtparam3:'',
            oper3:'like',
            repData:[],
            userCol:[] ,//表列集合
            v_corpid:this.$cookies.get('v_corpid') ,//公司id
            v_corpnm:this.$cookies.get('v_corpnm') ,//公司id
            userData:[] ,// 用户表
       
            v_url: 'xuper_auth/getTableRecMany', //api请求路径     
            v_likeurl:'xuper_auth/getLikeManyRec', //多记录查询 like模式      
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            loading:false,// table加载bool
            v_admin:this.$cookies.get('v_admin') ,//公司id
 
            type:'create',
            sendAuthCode:true,
            formCol:{userno:'',nation:'0086',code:'',pwd:'',usernm:''}, //表格单行记录 model
            auth_time: 0,  
            tabName:'user',
            menuList:[],    
            disabled:false,
            openName:[],
            listIndex:'-1',
            v_commit:true,
            allData:[],
            dataCount:0,
            rptWin:false,
            itemData:[],
            itemCol:[],
            v_roleid:[],
            rowSize:100,
            suptext:'',
            v_index:0,
            v_modnm:'',
            modidseq:'',
            repRow:{},
            repWin:false,
            btnWin:false,
            repArr:[],
            modData:[],
            v_userno:'',
            roleArr:[],
            allList:[],
            roleCol:[],
            roleData:[],
            roleRow:{},
            roleWin:false,
        }
    },
    created () {
 
        if (this.v_username){ 
            this.getFormData('') //初始查询用户表数据   
            this.getMenuList() //模块列数组
            this.loadTableColumns()  
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    components: { 
        pubWin,
        repDlg,
    },
    computed: {
        tabHigh(){
            return (window.innerHeight- 175)  + 'px'
        },
        tableHigh(){
            return (window.innerHeight- 140)  + 'px'
        },
        userHigh(){
            return (window.innerHeight- 420)  + 'px'
        },
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
        repHigh(){
            return (window.innerHeight- 450)  + 'px'
        },
    },
    mounted () {
        this.getModList()
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','V_PRIV_SUP','').then(res=>{
            this.supArr =res.result
        })
        //  操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData' ,'corpid',this.v_corpid,'','','V_sys_role','').then((res)=>{               
            this.roleArr =res.result
        })
    } ,
    watch: {
 
    },
    methods: {
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.userData = this.allList.slice(_start,_end);
        },
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.userData = this.allList          
            }else{
                this.userData =this.allList.slice(0,this.rowSize) 
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.refuser.doLayout()
                }, 100)
            })     
        },
        userDel(row,index){
            this.$confirm('你确定要删除此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ, p_table:'sys_user'},
                }).then(res=>{      
                    if(res.code =='200')  {           
                        this.userData.splice(index,1)  
                    }else{
                        this.$Message.error(res.result)
                    }        
                })     
            }).catch(err=>{})
        },
        //新增记录
        addRec(row){
            //this.empWin =true
            this.v_empRow =JSON.parse(JSON.stringify(row))
            this.v_key= 'staff'
            this.v_table ='v_hr_emp'
            this.tableCol =this.empCol
            this.v_key2=''
            this.v_value2 =''
            this.v_cond=' and stfg=\'Y\' and telno not in (SELECT userno FROM v_SYS_user )'
            this.btnWin =true           
            this.$nextTick(()=>{
                this.$refs['refWin'].qryTabData()
            })
        },
        //保存角色
        saveRole(){
            this.roleCol.filter(item=>item.notnull=='Y').some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.roleRow[item.key] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.title+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                this.v_commit =false
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.roleRow,{CORPID:this.v_corpid })), p_table:'SYS_ROLE',frmid:'89'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        this.roleWin =false   
                        this.getFormData('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
        },
        roleEdit(row,index){
            this.roleWin =true
            this.roleRow =JSON.parse(JSON.stringify(row))
        },
        roleDel(row,index){
            this.$confirm('你确定要删除此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {  p_table:'V_sys_user',p_key:'roleid',p_value:row['IDSEQ']},
                }).then(res=>{ 
                    if (res.result.length>0){
                        this.promptWin =true
                        this.prompt ='此记录下存在子记录，请核查'
                    }else{
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ, p_table:'sys_role'},
                        }).then(res=>{      
                            if(res.code =='200')  {           
                                this.roleData.splice(index,1)  
                            }else{
                                this.$Message.error(res.result)
                            }        
                        }) 
                    }
                })
                
            }).catch(err=>{})
        },
        addRole(){
            this.v_commit =true
            this.roleWin =true
            this.roleRow={'STFG':'Y',ISSEL:'Y',ISEDIT:'Y'}
        },    
        itemClick(val){
            this.v_tabName =val     
 
        },
        //字段查询
        inputQry(){
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.userCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
       
            this.getTabList(v_cond )
        },
        rowShow(){
            this.v_row  ={}
            this.inputQry()
        } ,
 
        //获取用户表单数据
        getTabList(v_cond){
            var vm=this
            getTabColOrData(this.v_likeurl,'v_sys_user','roleid',this.v_roleid,'','','','',v_cond+'  and corpid=\''+this.v_corpid+'\'').then((res) => {              
                vm.allList =res.result  
                this.initPage()   
                if(res.code!=='200'){  
                    this.promptWin =true
                    this.prompt =res.result
                }                    
            })        
        },
        //复制用户确认
        cpSave(){
            if (!this.v_fruser ){
                this.prompt ='请选择源角色'
                this.promptWin =true
            }else if ( this.v_fruser ==this.v_touser ){
                this.prompt ='源角色与目标角色不能相同'
                this.promptWin =true
            }else {
                this.$confirm('你确定要将源角色:'+this.v_frusernm+'的权限复制到目标角色:'+this.v_tousernm+' 吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    var vm=this
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/copyUserPriv',
                        data: {p_value:this.v_fruser,p_value2:this.v_touser  },
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            this.getModData(this.v_touser)
                            this.cpWin =false   
                        }else{
                            this.prompt=res.message
                            this.promptWin=true
                        }        
                    }) 
               
                }).catch(()=>{})
            } 
        },
        frChange(code){
            this.roleArr.some(item=>{
                if (item['IDSEQ']==code){
                    this.v_frusernm =item['ROLENM']
                }
            })
        },
        //密码修改
        pwdCfm(){   
            let pwd_ =this.NEWPWD
            let cfmpwd_=this.CFMPWD
            if (!pwd_){
                this.prompt ='新密码不能为空'
                this.promptWin=true
            }else if (!cfmpwd_){
                this.prompt ='确认密码不能为空'
                this.promptWin=true
            }else{
                if(pwd_.length<6){
                    this.prompt ='密码长度不能少于6位'
                    this.promptWin=true
                }else if(cfmpwd_.length<6){
                    this.prompt ='确认密码长度不能少于6位'
                    this.promptWin=true
                }else if(pwd_!==cfmpwd_){
                    this.prompt ='新密码和确认密码不匹配,请核查'
                    this.promptWin=true
                }else{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updatePassword',
                        data: {p_value:this.v_userno, p_table:'sys_user',p_value2:pwd_},
                    }).then(res=>{      
                        this.pwdWin =false   
       
                    })     
                }         
            }
        },
        setPwd(row){
            this.pwdWin =true
            this.NEWPWD=''
            this.CFMPWD=''
            this.v_userno =row['USERNO']
        },
        //模块列表
        getModList(){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {  p_table:'V_sys_mod',p_cond:' order by sortby '},
            }).then(res=>{   
                this.modData =res.result
                if (res.result.length>0){
                    this.modidseq =res.result[0]['MODIDSEQ']
                    this.v_modnm =res.result[0]['MODNM']
                    if (this.tabVal =='tab02') {
                        this.$nextTick(()=>{
                            this.$refs['refmod'].setCurrentRow(this.modData[0])
                        })
                    }
                    let  v_idseq =this.v_roleid
                  
                    this.qryRepData(v_idseq, res.result[0]['MODIDSEQ'])
                }  
            })
        },
        tabClick(val){
            this.tabVal =val
            if (this.tabVal =='tab02') {
                this.$nextTick(()=>{
                    this.$refs['refmod'].setCurrentRow(this.modData[0])
                })
            }
        },
        btnSure(obj){
            if (this.v_key =='REP'){
                Object.assign(this.repRow,{REPIDSEQ:obj['REPIDSEQ'],REPNM:obj['TITLE'],FRMNM:obj['FRMNM'],REPURL:obj['REPURL'],MODIDSEQ:obj['MODIDSEQ']  })
                this.rptWin =false
            }else{
                let v_json=[] 
                obj.forEach(item=>{
                    let v_row={IDNO:item['IDNO'],USERNO:item['TELNO'],USERNM:item['EMPNM'],DEPTNM:item['DEPTNM'],JOBNM:item['JOBNO'],PWD:'MjAyMg==',ROLEID:this.v_empRow['IDSEQ'],EMPIDSEQ:item['IDSEQ'],CORPID:this.v_corpid }  
                    v_json.push(v_row)                
                })
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/batDtlSave2',
                    data: {p_json:JSON.stringify(v_json), p_table:'SYS_USER',p_idseq:'', p_action:'S' },
                }).then(res=>{
                    if (res.code=='200'){
                        this.getUserList(this.v_empRow['IDSEQ'] )
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                    }  
                }) 
                this.btnWin =false
            }
            
        },
        inputBtn(key){
            this.v_key =key
            if (key=='REP'){
                this.v_table ='V_SYS_MOD_REP'
                this.tableCol =this.repArr
                this.v_key2='modidseq'
                this.v_value2 =this.modidseq+''
                this.rptWin =true
            } 
        },
        //分配报表
        repSure(){
            let  v_idseq =this.v_roleid
 
            this.$axios({
                method: 'post',
                url:'xuper_auth/tableBodySave',
                data: {p_json:JSON.stringify(Object.assign(this.repRow,{PRIVTY:'REPORT',IDSEQ:v_idseq})), p_table:'sys_user_priv',p_idseq:v_idseq},
            }).then(res=>{      
                if(res.code ==='200')  {          
                    this.repWin=false  
                    this.qryRepData(v_idseq,this.modidseq)
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }        
            }) 
        },
        addRep(){
            if (Object.keys(this.v_roleRow).length>0){
                this.repWin=true
                this.repRow={USERNM:this.v_roleRow['ROLENM'],IDSEQ:this.v_roleRow['IDSEQ'],USERNO:this.v_roleRow['IDNO'],MODNM:this.v_roleRow['ROLENM'] }
            }else{
                this.prompt='请先选中一条用户记录'
                this.promptWin=true
            }
        },
        delRec(row,index){
            this.$confirm('你确定要删除此行记录吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_table:'sys_user_priv'},
                }).then(res=>{      
                    if(res.code =='200')  {           
                        this.repData.splice(index,1)  
                    }else{
                        this.$Message.error(res.message)
                    }        
                }) 
            }).catch(()=>{})
        },
        repChange(){
            let v_idseq =this.v_roleid
 
            this.qryRepData(v_idseq,this.modidseq)
        },
        //查询报表
        qryRepData(userid,modidseq){
            let cond_=''
            if (this.selparam3 && this.txtparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and upper('+this.selparam3+') like upper(\'%' + this.txtparam3+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam3+')' +this.oper3+'upper(\''+this.txtparam3+'\')'
                }
            }
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'userid', p_value:userid,p_key2:'modidseq', p_value2:modidseq, p_cond:cond_,p_table:'V_ROLE_MOD_REP'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.repData =res.result
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            }) 
        },
        modRow(row){
            this.modidseq =row.IDSEQ
            this.v_modnm =row['MODNM']
            this.qryRepData(this.v_roleid , row['IDSEQ'])   
          
        } , 
  
        //角色--人员
        addEmp(val){
            this.v_roleid =this.v_row['IDSEQ']
            if (val =='S'){
                this.v_key= 'supno'
                this.v_table ='v_bs_sup'
                this.tableCol =this.factCol
                this.v_key2=''
                this.v_value2 =''
                this.t_cond=' and idno not in (SELECT empno FROM v_SYS_user)'
                this.btnWin =true
                this.$nextTick(()=>{
                    this.$refs['refWin'].qryTabData()
                })
            }else{
                this.v_key= 'staff'
                this.v_table ='v_hr_emp'
                this.tableCol =this.empCol
                this.v_key2=''
                this.v_value2 =''
                this.v_cond=' and stfg=\'Y\' and idno not in (SELECT empno FROM v_SYS_user)'
                this.btnWin =true           
                this.$nextTick(()=>{
                    this.$refs['refWin'].qryTabData()
                })
                
            }
            this.empWin =false
        },
 
 
        getRowKey(row){
            return row['IDSEQ'] 
        },
        getDtlKey(row){
            if (row['IDSEQ'] && row['LSTSEQ'] )
            return row['IDSEQ']+'/'+row['LSTSEQ']
        },
        saveRec(stfg){      
          if (this.v_admin==='Y'){        
            //发起保存请求   
            var vm=this,v_action='', gpno_=''
            let v_idseq =this.v_roleid
            for(let k=0;k<this.menuList.length;k++){
                for(let m=0;m<this.menuList[k].children.length;m++){
                    let rowCol=this.menuList[k].children[m]
                    gpno_ =''
                    v_action='USER'
                    if (rowCol.sel==='Y' ){
                        if (gpno_===''){gpno_='sel'}else{gpno_=gpno_+','+'sel'}
                    }
                    if (rowCol.ins==='Y' ){
                        if (gpno_===''){gpno_='add'}else{gpno_=gpno_+','+'add'}
                    }if (rowCol.upd==='Y' ){
                        if (gpno_===''){gpno_='upd'}else{gpno_=gpno_+','+'upd'}
                    }if (rowCol.del==='Y' ){
                        if (gpno_===''){gpno_='del'}else{gpno_=gpno_+','+'del'}
                    }if (rowCol.cfm==='Y' ){
                        if (gpno_===''){gpno_='cfm'}else{gpno_=gpno_+','+'cfm'}
                    }if (rowCol.cancel==='Y' ){
                        if (gpno_===''){gpno_='cancel'}else{gpno_=gpno_+','+'cancel'}
                    }if (rowCol.exp==='Y' ){
                        if (gpno_===''){gpno_='exp'}else{gpno_=gpno_+','+'exp'}
                    }if (rowCol.oth==='Y' ){
                        if (gpno_===''){gpno_='oth'}else{gpno_=gpno_+','+'oth'}
                    }
                    this.$axios({  //P_JSON  ,P_TABLE ,P_USER ,P_OPTION ,P_OPER ,P_ACTION 
                        method: 'post',
                        url:'xuper_auth/saveUserModForm',
                        data: {p_json:JSON.stringify(rowCol ), p_table:'SYS_USER_PRIV',p_user:v_idseq,p_action:v_action,gpno:gpno_,p_oper:vm.v_username},
                    })
                }   
                vm.getModData(v_idseq)
            }
            this.$message({
                message: '已成功保存',
                duration:2000,
                type: 'success'
            })
            vm.getModData(v_idseq)
          }else{
              this.prompt='仅有主账号才能操作'
              this.promtWin=true
          }
        },
        //模块选择
        modSelect(oper,index,value){
            if (value==='Y'){
                for (let k=0;k<this.menuList[index].children.length;k++){
                    if (oper==='S'){
                        this.menuList[index].children[k].sel='Y'
                    }else if (oper==='I'){
                        this.menuList[index].children[k].ins='Y'
                    }else if (oper==='U'){
                        this.menuList[index].children[k].upd='Y'
                    }else if (oper==='D'){
                        this.menuList[index].children[k].del='Y'
                    }else if (oper==='C'){
                        this.menuList[index].children[k].cfm='Y'
                    }else if (oper==='X'){
                        this.menuList[index].children[k].cancel='Y'
                    }else if (oper==='E'){
                        this.menuList[index].children[k].exp='Y'
                    }else if (oper==='T'){
                        this.menuList[index].children[k].oth='Y'
                    }
                }
            }else{
                for (let k=0;k<this.menuList[index].children.length;k++){
                    if (oper==='S'){
                        this.menuList[index].children[k].sel='N'
                    }else if (oper==='I'){
                        this.menuList[index].children[k].ins='N'
                    }else if (oper==='U'){
                        this.menuList[index].children[k].upd='N'
                    }else if (oper==='D'){
                        this.menuList[index].children[k].del='N'
                    }else if (oper==='C'){
                        this.menuList[index].children[k].cfm='N'
                    }else if (oper==='X'){
                        this.menuList[index].children[k].cancel='N'
                    }else if (oper==='E'){
                        this.menuList[index].children[k].exp='N'
                    } else if (oper==='T'){
                        this.menuList[index].children[k].oth='N'
                    }
                }
            }
        },
        //一级菜单点击
        menuClick(index,code){
            this.listIndex =index
            this.menuBool=!this.menuBool
            if (this.openName.indexOf(code)===-1){
                this.openName.push(code)
            }else{
                this.openName.splice(this.openName.indexOf(code),1)
            }
        },
        //模块表单菜单
        getMenuList(){
            this.$axios({
                method:'post',
                url: 'xuper_auth/getSystemMenu' ,
                data:{},
            }).then(res =>{
                if (res.code==='200'){
                    this.menuList =res.result
                    //默认全展开
                    for (let k=0;k<res.result.length;k++){
                        this.openName.push(res.result[k].code)
                    } 
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
 
        //复制 用户或角色
        cpRec(row){
            this.cpWin =true
            this.v_fruser=''
            this.frusernm =''
            this.v_tousernm =  row['IDNO'] +'  '+row['ROLENM']
            this.v_touser =row['IDSEQ']
        },
        //加载表列头字段
        async loadTableColumns() {
            try{
                this.roleCol = await getTab_Column(this.v_url,'v_sys_form_fld','idseq','89','lstseq','2', '' )
                this.userCol = await getTab_Column(this.v_url,'v_sys_form_fld','idseq','89','lstseq','1', '' )
                this.modCol = await getTab_Column(this.v_url,'v_sys_form_fld','idseq','89','lstseq','5', '' )
                this.empCol = await getTab_Column(this.v_url,'v_sys_form_fld','idseq','4204','lstseq','4', '' )
                this.itemCol = await getTab_Column(this.v_url,'v_sys_form_fld','idseq','89','lstseq','7', '' )
                this.repCol = await getTab_Column(this.v_url,'v_sys_form_fld','idseq','89','lstseq','4', '' )
                this.repArr = await getTab_Column(this.v_url,'v_sys_form_fld','idseq','88','lstseq','2504', '' )
            }catch(error){
                this.roleCol =[]
                this.userCol =[]
                this.modCol =[]
                this.itemCol =[]
                this.repCol =[]
                this.repArr =[]
            }
        },
 
        //获取模块表单数据
        getModData(idseq){
            
            this.$axios({
                method:'post',
                url: '/xuper_oss/getUserMenu' ,
                data:{p_idseq:idseq  },
            }).then(res =>{                
                if (res.code=='200'){
                    
                    this.menuList =res.result
                }else{
                    this.promtWin =true
                    this.prompt =res.result
                }
                
            })           
        },
 
        //变更主账号
        setRec(row,index,val){
            const v_comm =val=='Y'?'你确定要设置AI权限吗':'你确定要取消AI权限吗'
            this.$confirm(v_comm,'提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],p_table:'sys_user',p_cond:' set ISAI=\''+val+'\'' },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        row['ISAI']=val    
                    }else{
                        this.prompt=res.message
                        this.promtWin=true
                    }        
                }) 
            
            }).catch(()=>{})
 
        },
 
        //查询选择器事件
        elchange(value){
            let obj ={}
            obj =this.userCol.find(item=>{
                return item.key===value
            })
            if (obj)
            this.input_hold='请输入'+obj.title+' 的值'
        },
        //查询表格数据
        qryTabData(){
            let cond_ =''
            if (this.selparam ){
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                }else{
                    if (this.txtparam){
                        cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                    }
                }
            }
            this.getFormData(cond_)  
        },
 
        rowClick(row ) {
            this.v_roleid =row.IDSEQ
            this.getModData( row.IDSEQ )
            this.getUserList(row.IDSEQ)
            this.getModList()
            this.v_roleRow=JSON.parse(JSON.stringify(row))
        },
 
 
        //获取用户表单数据
        getFormData(v_cond){
            var vm=this
            getTabColOrData(this.v_url,'V_sys_role','CORPID',this.v_corpid,'','','','',v_cond+' order by '+this.selparam+' desc').then((res) => {              
                vm.roleData =res.result   
                vm.$nextTick(() => {
       
                    setTimeout(() => {
                        vm.$refs['refrole'].doLayout()
                        vm.$refs['refrole'].setCurrentRow(res.result[0])
                    }, 200)
                })
                this.v_roleRow =JSON.parse(JSON.stringify(res.result[0]))
                this.v_roleid = res.result[0].IDSEQ
 
                this.getUserList(this.v_roleid)  
                this.getModData(this.v_roleid) 
            }) 
        },
        getUserList(idseq){
            this.userData=[]
            getTabColOrData(this.v_likeurl,'v_sys_user','ROLEID',idseq,'CORPID',this.v_corpid,'','',' order by userno').then((res) => { 
                this.allList =res.result  
                this.initPage() 
                 
            })
        },
 
    }
}
 
</script>
<style scoped  lang="less">
    .oneButton{
        display:flex;
        background: aliceblue;
        margin-top:1px ;
        margin-bottom:1px;
    }
    .oneButton:hover{
        background:rgb(224, 245, 252);
        cursor: pointer;
    }
    .tabMenu{
        height:30px;
        line-height:30px;
        background:white;
    }
    .tabMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
   .item-width  {
        width: 48%;
        color:#409EFF;
    }
   .btn{
       width:80%;
       margin-top:100px;
       height:40px;
       margin-left:5px;
       margin-right:5px;
   }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:12px;
        font-size:14px;
        font-weight:550;
        color:#5cadff;
        background-color: #dcdee2;  
        display:flex;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#19be6b;
    }   
 
    .active { 
        border-bottom:3px solid #cc0000;
        color:#389;
    }
    .oneTab{
        height:30px;
        line-height:30px;
        background:white;
    }
    .oneTab:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#19be6b;
        background:#e8eaec;
    }
</style>
 
